
<div class="custom-box1">

  <div class="col-xs-12 col-md-12 col-lg-12 card tender-auction-section1">
  
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">
          <a href="#"> <img _ngcontent-qho-c122="" src="content/images/home-icon.svg" title="home-icon" class="img-fluid">Home</a>
        </li>
  
  
      </ol>
    
    <div class="row">
      <div class="col-md-3 d-flex">
      <select (change)="ontableSizeChange($event)" class="form-select-sm show_entries">
        <option *ngFor="let size of tableSizes">
          {{size}}
        </option>
      </select>
      
      </div>
      <div class="col-md-6">      
      </div>
  
      <div class=" col-md-3">
        <pagination-controls previousLabel="Prev" nextLabel="Next"
        (pageChange)="onTableDataChange((page = $event))"></pagination-controls>
      
      
      </div>
    </div>
    
    
    <div class="custom-scroll-bar hei ght-auto">
    <div class="common-table custom-scroll-bar height-auto">
      <table class="table table-hover table-bordered table-striped shadow" >
      <thead class="table-light">
        <tr>
          <th>S.No.</th>
          <th>Category</th>
          <th>Sub-Category</th>
          <th>Description</th>
          <th>Document</th>
  
        </tr>
      </thead>
      <tbody class="customizeHeight ">
        <tr scope="row"
              
         *ngFor="let solrloop of solrData| paginate :{itemsPerPage :tableSize,currentPage: page,totalItems:count}; let i=index;" >
          <td>{{ (page - 1) * tableSize + i + 1 }}</td>
          <td>{{solrloop.menu_type}}</td>
            <td>{{solrloop.category}}</td>
            
            <td>{{solrloop.titleEn}}</td>
            <td>
              <a [routerLink]="" class="tble_desc" (click)="ViewPdf(solrloop.filePathEn)"><span ngClass="{{utils.getDocumentIcon(solrloop.docType)}}">         
              </span></a>
            </td>
        </tr>
          <!-- <th scope="row">{{ (page - 1) * tableSize + i + 1 }}</th>    -->
          
        
        
      </tbody>
      
    </table>
    </div>
    </div>
  </div>
  </div>